export default __webpack_public_path__ + "static/media/view_for_employers.888daf62.svg";